import { render, staticRenderFns } from "./FbpConfigure.vue?vue&type=template&id=79f2acb0&scoped=true"
import script from "./FbpConfigure.vue?vue&type=script&lang=js"
export * from "./FbpConfigure.vue?vue&type=script&lang=js"
import style0 from "./FbpConfigure.vue?vue&type=style&index=0&id=79f2acb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f2acb0",
  null
  
)

export default component.exports